export const CURRENT_CONTENT_SEASON = 'Season 7';
export const LEGACY_VIDEO_SEASON = 'Season 6';

const getContentText = (item = {}) => [
  item.season,
  item.seasonName,
  item.seasonLabel,
  item.intake,
  item.title,
  item.module,
  item.content,
  item.description,
  item.details?.overview
]
  .filter(Boolean)
  .join(' ')
  .toLowerCase();

export const isCurrentSeasonContent = (item = {}) => {
  const explicitSeason = [item.season, item.seasonName, item.seasonLabel]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

  if (explicitSeason) {
    return explicitSeason.includes('season 7') || explicitSeason.includes('season seven');
  }

  const text = getContentText(item);
  return text.includes('season 7') || text.includes('season seven');
};

export const getResourceFolder = (resource = {}) => {
  const explicitSeason = [resource.season, resource.seasonName, resource.seasonLabel, resource.folder]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

  if (explicitSeason.includes('season 6') || explicitSeason.includes('season six')) {
    return LEGACY_VIDEO_SEASON;
  }
  if (explicitSeason.includes('season 7') || explicitSeason.includes('season seven')) {
    return CURRENT_CONTENT_SEASON;
  }

  const type = String(resource.type || resource.resourceType || '').toLowerCase();
  return type === 'video' || resource.embedUrl ? LEGACY_VIDEO_SEASON : CURRENT_CONTENT_SEASON;
};
